import { useQuery } from "@tanstack/react-query";
import { getProjectInvitations } from "@/app/actions/project-member/action";
import { QueryKey } from "@/app/vars/QueryKeys";

export function useFetchProjectInvitations(
  options: { projectId?: number; enabled?: boolean } = {},
) {
  const { projectId, enabled = true } = options;

  return useQuery({
    queryKey: [QueryKey.PROJECT_INVITATIONS, projectId],
    queryFn: () => getProjectInvitations(projectId!),
    enabled: enabled && !!projectId,
    staleTime: Infinity,
  });
}
